// extracted by mini-css-extract-plugin
var _1 = "PdfViewerThumbnail-modulePdfViewerThumbnail__mOfEm";
var _2 = "PdfViewerThumbnail-moduleactive__WYv5b";
var _3 = "PdfViewerThumbnail-modulecanvas__K46ZF";
var _4 = "PdfViewerThumbnail-modulepageNumber__uWw5i";
export { _1 as "PdfViewerThumbnail", _2 as "active", _3 as "canvas", _4 as "pageNumber" }
